<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep2ogvtn.vue
*@ 컴포넌트설명 :[베트남] 예금 상품 > 금리 안내(기업고객)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <h6>USD</h6>
      <!-- 개인 고객 -->
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-22") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*상품*/ $t("MDEP-01-02-02-11") }}</th>
          <th scope="col">{{ /*기본금리*/ $t("MDEP-01-02-02-12") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ /*요구불*/ $t("MDEP-01-02-02-13") }}</td>
          <td>0.00</td>
        </tr>
        <tr>
          <td>{{ /*정기예금*/ $t("MDEP-01-02-02-04") }}</td>
          <td>0.00</td>
        </tr>
      </tbody>
    </table>
    <div class="cont-tit">
      <h6>VND</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-22") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*상품*/ $t("MDEP-01-02-02-11") }}</th>
          <th scope="col">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
          <th scope="col">{{ /*기본금리*/ $t("MDEP-01-02-02-12") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ /*요구불*/ $t("MDEP-01-02-02-13") }}</td>
          <td></td>
          <td>0.10</td>
        </tr>
        <tr>
          <td rowspan="4">{{ /*정기예금*/ $t("MDEP-01-02-02-04") }}</td>
          <td>
            1
            <span>{{ /*개월*/ $t("MDEP-01-02-01-12") }}</span>
          </td>
          <td>2.00</td>
        </tr>
        <tr>
          <td>
            3
            <span>{{ /*개월*/ $t("MDEP-01-02-01-12") }}</span>
          </td>
          <td>2.50</td>
        </tr>
        <tr>
          <td>
            6
            <span>{{ /*개월*/ $t("MDEP-01-02-01-12") }}</span>
          </td>
          <td>3.30</td>
        </tr>
        <tr>
          <td>12{{ /*개월*/ $t("MDEP-01-02-01-12") }} {{ /*이상*/ $t("MDEP-01-02-02-14") }}</td>
          <td>3.90</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      currentTab: 1,
    };
  },
};
</script>